export { LandingPageRoutes } from './routes';
